
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import { isNonSubscribableFilter } from "@/helpers/SearchHelper";

export default defineComponent({
  name: "ButtonApplyFilters",
  emits: ["applyFilters"],
  computed: {
    ...mapGetters(['filters', 'isLoading', 'filterUpdated']),
    isDisabled() {
      return (Object.keys(this.filters).length === 0 && !this.filterUpdated) || 
        (isNonSubscribableFilter(this.filters) && !this.filterUpdated) || 
        this.isLoading
    }
  },
});
